"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ogBetProviderSaga = exports.ogQuickBetErrorSaga = exports.ogBetSaga = void 0;
const effects_1 = require("redux-saga/effects");
const slice_1 = require("./slice");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const storage_1 = require("../../utils/storage");
const constants_1 = require("../../utils/storage/constants");
const uuid_1 = require("uuid");
const types_1 = require("./types");
const selectors_1 = require("./selectors");
const constants_2 = require("astra-core/containers/BasketProvider/constants");
const slice_2 = require("astra-core/containers/BasketProvider/slice");
const BetsProvider_1 = require("astra-core/containers/BetsProvider");
const bet_1 = require("../../utils/bet");
const SettingsProvider_1 = require("astra-core/containers/SettingsProvider");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* ogQuickBetConfirmSaga(action) {
    const { outcome, outcomeId, notifyCallback } = action.payload;
    const id = outcomeId !== null && outcomeId !== void 0 ? outcomeId : (0, uuid_1.v4)();
    const quickBetAmount = yield (0, effects_1.select)(SettingsProvider_1.selectSettingsDataProp, 'quickBetAmount');
    const shouldConfirmQuickBet = (0, storage_1.getLocalStorageItem)(constants_1.StorageKeys.shouldConfirmQuickBet, true);
    const modal = yield (0, effects_1.select)(selectors_1.selectQuickBetModal);
    if (shouldConfirmQuickBet && modal === null) {
        yield (0, effects_1.put)(slice_1.ogBetProviderActions.setQuickBetModal({
            type: types_1.QuickBetModalsTypes.confirmQuickBet,
            data: {
                quickBetAmount,
                outcome,
            },
        }));
        return;
    }
    const saveAny = yield (0, effects_1.call)(storage_1.getLocalStorageItem, constants_1.StorageKeys.quickBetSaveAnyStatus, betweb_openapi_axios_1.BetSaveAny.Always);
    if (notifyCallback !== undefined) {
        notifyCallback({ outcomeId: id });
    }
    yield (0, effects_1.put)(BetsProvider_1.betsProviderActions.makeQuickBet({ outcome, outcomeId: id, saveAny }));
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* ogBetSaga(payload) {
    const { eventProbability, eventStatus, eventId, live, notifyCallback } = payload;
    if (eventProbability === undefined) {
        return;
    }
    const isQuickBetActive = yield (0, effects_1.select)(BetsProvider_1.selectIsQuickBetActive);
    if (isQuickBetActive) {
        const bet = {
            coefficient: eventProbability.odd,
            outcomeCompositeId: {
                eventId,
                live,
                outcomeTypeId: eventProbability.outcomeTypeId,
                parameters: eventProbability.parameters,
            },
        };
        yield (0, effects_1.put)(slice_1.ogBetProviderActions.confirmQuickBet({
            outcome: bet,
            notifyCallback,
        }));
        return;
    }
    const isAddBasket = constants_2.activeEventStatus.includes(eventStatus) &&
        constants_2.activeProbabilityStatus.includes(eventProbability.tradingStatus);
    if (isAddBasket) {
        yield (0, effects_1.put)(slice_2.basketProviderActions.addOutcomeToBasket({
            eventProbability,
            eventId,
        }));
    }
}
exports.ogBetSaga = ogBetSaga;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* ogQuickBetErrorSaga(action) {
    const { error, outcomeId, outcome } = action.payload;
    const modalData = (0, bet_1.getQuickBetModalData)(error, outcome, outcomeId);
    if (modalData !== null) {
        yield (0, effects_1.put)(slice_1.ogBetProviderActions.setQuickBetModal(modalData));
    }
}
exports.ogQuickBetErrorSaga = ogQuickBetErrorSaga;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* ogBetProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeEvery)(slice_1.ogBetProviderActions.confirmQuickBet, ogQuickBetConfirmSaga),
        (0, effects_1.takeEvery)(BetsProvider_1.betsProviderActions.makeQuickBetError, ogQuickBetErrorSaga),
    ]);
}
exports.ogBetProviderSaga = ogBetProviderSaga;
//# sourceMappingURL=saga.js.map